<template>
  <section>
<!--    <h2 class="h2Title">{{board.boardName}}</h2>-->
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="게시물 생성일"
                                        :value="param.searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>

              <dl>
                <dd>
                  <v-select v-model="param.searchCategory" :items="categoryItems" item-text="categoryName"
                            item-value="categoryId" label="카테고리"
                            dense
                            clearable
                            flat
                            outlined
                            v-on:change="search"
                  />
                </dd>
              </dl>

              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="제목 / 내용 / 작성자 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
<!--          <div class="searchBtn">-->
<!--            <v-btn color="#424964" @click="search()" depressed dark>검색</v-btn>-->
<!--          </div>-->
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="$router.push({path: 'article/form'})" color="#666" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                등록
              </v-btn>
            </li>
            <li class="tableBtnList" v-if="board.boardType === 'TYPE_SCHEDULE'">
              <v-btn class="vBtn vIconResize mgr" @click="showCalendar" color="success" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                달력 보기
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers.filter(h => h.value !== 'boardCategory.categoryName' || (this.board.boardCategories && this.board.boardCategories.length > 0))"
            :items="articles"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="articleId"
            class="elevation-1"
            :footer-props="{showFirstLastPage: true}"
            disable-sort
        >
          <template v-slot:item.no="{item}">
            <template v-if="item.notice">
              공지
            </template>
            <template v-else>
              {{item.idx}}
            </template>
          </template>

          <template v-slot:item.title="{value, item}">
            <a @click.stop="onRowClick(item)">
            {{ value }}
            </a>
          </template>

          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

          <template v-slot:item.deleted="{ value }">
            {{ value ? '사용' : '사용안함' }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click.stop="updateForm(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                @click.stop="deleteArticle(item)"
            >
              mdi-delete
            </v-icon>
          </template>

        </v-data-table>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";

import boardApi from '@/api/BoardApi'
import articleApi from '@/api/ArticleApi'
import roleApi from '@/api/RoleApi'
import _ from "lodash";

export default {
  name: "Article",
  components: {
    'date-range-component': DateRageComponent
  },
  data: () => ({
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    activeItem: null,
    selected: [],
    headers: [
      {text: '번호', value: 'no', align: 'left'},
      {text: '제목', value: 'title', align: 'left'},
      {text: '카테고리', value: 'boardCategory.categoryName'},
      {text: '작성자', value: 'writer', align: 'center'},
      {text: '작성일', value: 'createdAt'},
      {text: '조회수', value: 'hits'},
      {text: '삭제여부', value: 'deleted', align: 'left'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchDate:[],
      searchState: null,
      searchRole: null,
      searchKeyword: null,
      page: 1
    },
    articles: [],
    totalItems: 0,
    dialogVisible: false,
    selectArticle: {},
    waitingSearch: false,
    board: {},
    options:{},
    categoryItems: [],
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv, ov) {
        if(nv === ov)
          return;
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler(nv, ov) {
        if(nv === ov)
          return;
        this.search();
      },
      deep: true
    }
  },
  methods: {
    onRowClick(item) {
      this.$router.push({path:`/board/${item.boardId}/article/view/${item.articleId}`});
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
      // watch param.searchDate
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
      // this.search(); // watch param.searchDate
    },
    search() {
      // console.log(this.options);
      const {  page, itemsPerPage, size } = this.options;

      let params = {...this.param, ...{
            page: page,
            size: size ? size : itemsPerPage
      }};

      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      articleApi.list(this.$route.params.id, params).then(data => {
        this.totalItems = data.totalElements;
        this.articles = data.content.map((a, i) => {
          a.idx = this.totalItems - i - (( (params.page??1) - 1) * params.size);
          return a;
        });
        this.$store.commit('setParams', params);
      });
    },
    showCalendar() {
      this.$emit('callback-change-list', 'TYPE_SCHEDULE');
    },
    updateForm(item) {
      this.selectArticle = _.cloneDeep(item);
      this.$router.push({path:`/board/${item.boardId}/article/form/${item.articleId}`});
    },
    deleteArticle(item) {
      if(confirm('삭제하시겠습니까?')) {
        articleApi.delete(item.boardId, item.articleId).then(() => {
          this.search();
        });
      }
    }
  },
  created: function () {
    roleApi.list(true).then(data => {
      this.boardRoleItems = data;
    });
    boardApi.get(this.$route.params.id).then(data => {
      this.board = data;
      this.categoryItems = (data.boardCategories??[]).length > 0 ? data.boardCategories : null;
    });

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

    // console.log(this.$store.state.currentMenu)
    // console.log(this.$store.getters.menu)
    // console.log(this.$store.getters.params)

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
